.content {
    max-width: 440px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.animation-container {
    width: 275px;
    height: 225px;
    border-radius: 16px;
    overflow: hidden;
    display: flex;
}
